export default "__VITE_ASSET__nbhGHpBL__"